import { Base } from '../../../../../common/models';
import { AllocationViewFiltersModel } from './allocation-view-filters.model';
import { ListQueryParam } from '../../../../../common/constants';
import { ALLOCATION_TERMINAL_VIEW_DEFAULT_PAGE_SIZE } from '../constants/allocation-view.constant';

export class AllocationViewListSearchCriteria extends AllocationViewFiltersModel {
  [ListQueryParam.Size] = ALLOCATION_TERMINAL_VIEW_DEFAULT_PAGE_SIZE;
  [ListQueryParam.Page] = 0;
  id?: string;
  name?: string;
  hubId: number;

  constructor(params?: Partial<AllocationViewListSearchCriteria> | Base) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AllocationViewCalendarSearchCriteria extends AllocationViewListSearchCriteria {
  constructor(params?: Partial<AllocationViewCalendarSearchCriteria> | Base) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
